<template>
  <div :class="['dialog', { visible: visible }]">
    <div class="title">{{ company.companyName }}</div>
    <div class="closeBtn" @click="visible = false"></div>
    <div class="content">
      <a-tabs>
        <a-tab-pane key="1" tab="商品">
          <div class="list">
            <div v-for="item in productList" :key="item.id" class="list-item">
              <div class="cover">
                <img :src="item.picList[0]" alt="" />
                <div class="badge">{{ item.tradeType }}</div>
              </div>
              <div class="name two-line">{{ item.name }}</div>
            </div>
          </div>
          <a-pagination
            v-model="current"
            :page-size="size"
            :total="total"
            show-less-items
            @change="onProductChange"
          />
        </a-tab-pane>
        <a-tab-pane key="2" tab="订单">
          <a-table
            bordered
            :columns="columns"
            :data-source="orderList"
            :pagination="pagination"
            :scroll="{ y: 1050 }"
            @change="onOrderChange"
          >
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>
<script>
import { areaCompanyProduct, areaCompanyOrder } from '@/api/dashboard'
import to from 'await-to'
export default {
  name: 'Product',
  data() {
    return {
      visible: false,
      productList: [],
      current: 1,
      size: 27,
      total: 0,
      columns: [
        {
          title: '订单号',
          dataIndex: 'orderNumber',
          key: 'orderNumber',
          align: 'center',
          width: 110,
        },
        {
          title: '企业客户',
          dataIndex: 'customerName',
          key: 'customerName',
          align: 'center',
          width: 80,
        },
        {
          title: '订单详情',
          dataIndex: 'materialInfo',
          key: 'materialInfo',
          align: 'center',
          width: 300,
        },
        {
          title: '订单金额（元）',
          dataIndex: 'orderAmount',
          key: 'orderAmount',
          align: 'center',
          width: 80,
        },
        {
          title: '支付方式',
          dataIndex: 'paymentMethod',
          key: 'paymentMethod',
          align: 'center',
          width: 70,
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          key: 'orderType',
          align: 'center',
          width: 70,
        },
        {
          title: '创建时间',
          dataIndex: 'transactionTime',
          key: 'transactionTime',
          align: 'center',
          width: 100,
        },
      ],
      orderList: [],
      pagination: {
        current: 1,
        pageSize: 11,
        total: 0,
      },
      company: {},
    }
  },
  methods: {
    show(options) {
      console.log(`output->options`, options)
      this.company = options
      this.visible = true
      this.getProduct()
      this.getOrder()
    },
    close() {
      this.visible = false
    },
    async getProduct() {
      const [res, err] = await to(
        areaCompanyProduct({ companyId: this.company.id, current: this.current, size: this.size }),
      )
      if (err) return
      this.productList = res.data.list
      this.total = res.data.total
    },
    onProductChange(current) {
      this.current = current
      this.getProduct()
    },
    onOrderChange({ current }) {
      console.log(`output->current`, current)
      this.pagination.current = current
      this.getOrder()
    },
    async getOrder() {
      const [res, err] = await to(
        areaCompanyOrder({
          companyId: this.company.id,
          current: this.pagination.current,
          size: this.pagination.pageSize,
        }),
      )
      if (err) return
      this.orderList = res.data.list
      this.pagination.total = res.data.total
    },
  },
}
</script>
<style lang="scss" scoped>
.dialog {
  z-index: 99999999;
  width: 3212px !important;
  height: 1564px !important;
  background: url('~@/img/datav/dialog_bg.png');
  background-size: 100% 100%;
  position: absolute;
  left: 329px;
  top: 423px;
  display: none;

  .title {
    font-size: 57px;
    text-align: center;
    line-height: 107px;
    margin-bottom: 20px;
  }

  .closeBtn {
    cursor: pointer;
    width: 58px;
    height: 58px;
    position: absolute;
    right: 40px;
    top: 34px;
    background: url('~@/img/datav/dialog_close_btn.png');
    background-size: 100% 100%;
  }

  .content {
    height: 1400px;
    padding: 0 194px;

    ::v-deep .ant-tabs {
      height: 100%;

      .ant-tabs-nav .ant-tabs-tab {
        font-size: 40px;
        color: #e8e8e8;

        &.ant-tabs-tab-active {
          color: #40a9ff;
        }
      }
    }

    .list {
      display: flex;
      flex-wrap: wrap;

      .list-item {
        width: 263px;
        height: 327px;
        margin-right: 46px;
        margin-bottom: 54px;
        padding: 21px 26px 19px;
        box-sizing: border-box;
        background: linear-gradient(180deg, rgba(20, 95, 163, 0.41), rgba(23, 77, 168, 0.24));

        &:nth-of-type(9n) {
          margin-right: 0;
        }

        .cover {
          position: relative;
          width: 210px;
          height: 210px;
          margin-bottom: 18px;

          .badge {
            position: absolute;
            top: 10px;
            left: 10px;
            padding: 0 7px;
            font-size: 12px;
            line-height: 20px;
            color: #fafafa;
            background: rgba(0, 25, 72, 0.7);
            border-radius: 4px;
          }

          img {
            width: 100%;
            height: 100%;
          }
        }

        .name {
          font-weight: normal;
          font-size: 24px;
          color: #ffffff;
          height: 58px;
          line-height: 30px;
        }
      }
    }

    ::v-deep .ant-table {
      p {
        margin-bottom: 10px;
      }

      table {
        border-left: 1px solid #f5f5f5;
        border-top: 1px solid #f5f5f5;
      }

      .ant-table-thead {
        box-sizing: border-box;
        border: 0;
        border-color: #f5f5f5;
        font-size: 36px;
        line-height: 36px;
        background: #fff linear-gradient(180deg, #145fa3, #174da8);

        > tr > th {
          background: transparent;
          color: #fff;
          border-color: #f5f5f5;
          padding-top: 42px;
          padding-bottom: 42px;
        }
      }

      .ant-table-header {
        background: transparent;
      }

      .ant-table-body {
        background: transparent;

        /* 设置滚动条的样式 */
        &::-webkit-scrollbar {
          border-radius: 15px;
          width: 17px;
          background-color: transparent;
        }

        /* 滚动槽 */
        &::-webkit-scrollbar-track {
          border-radius: 15px;
          background-color: transparent;
        }

        /* 滚动条滑块 */
        &::-webkit-scrollbar-thumb {
          border-radius: 15px;
          background: #46629a;
        }
      }

      .ant-table-tbody {
        font-size: 30px;
        line-height: 30px;
        color: #fff;

        > tr > td {
          border-color: #f5f5f5;
          padding-top: 29px;
          padding-bottom: 29px;
        }

        > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
          background: transparent;
        }
      }

      .ant-table-placeholder {
        background: transparent;
      }
    }

    ::v-deep .ant-pagination {
      width: 100%;
      text-align: center;

      > li {
        width: 58px;
        height: 58px;
        box-sizing: border-box;
        border: 2px solid #46639a;
        font-weight: normal;
        font-size: 24px;
        line-height: 54px;
        text-align: center;
        background-color: transparent;
        margin: 0 10px;

        .ant-pagination-item-link {
          background-color: transparent;
          border: 0;
        }

        a {
          color: #46629a;
        }

        &.ant-pagination-item-active {
          background-color: #46629a;

          a {
            color: #fff;
          }
        }
      }
    }
  }

  &.visible {
    display: block;
    animation: anim-open 0.5s ease;
  }

  @keyframes anim-open {
    0% {
      transform: scale(0);
    }

    100% {
      transform: scale(1);
    }
  }
}
</style>
